module.exports = "<div class=\"m-knowledge-tab-item\">\r\n    <div class=\"icon\">\r\n        <i class=\"u-icon\" :class=\"item.icon\"></i>\r\n    </div>\r\n    <div class=\"title\">{{item.title}}</div>\r\n    <div class=\"subtitle\">{{item.subtitle}}</div>\r\n    <div class=\"control\">{{controlText}}</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./product-detail/component/knowledge-tab-item.html
// module id = 207
// module chunks = 0